export default __webpack_public_path__ + "static/media/special-notes-img.bb82f0cd.png";